import { Navigate, useLocation } from 'react-router-dom';
import { type ReactNode } from 'react';
import { useAdminAuth } from '@/contexts/AdminAuthContext';

interface AdminPrivateRouteProps {
  children: ReactNode;
}

export default function AdminPrivateRoute({ children }: AdminPrivateRouteProps) {
  const location = useLocation();
  const { isAuthenticated } = useAdminAuth();

  if (!isAuthenticated) {
    return (
      <Navigate
        to="/admin/login"
        replace
        state={{ from: location.pathname }}
      />
    );
  }

  return <>{children}</>;
}